import React from "react";
import { C as T, btn } from "../theme/colors";
import { reportClientError } from "../utils/clientErrorLogger";

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  message: string;
};

class ErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
    message: "",
  };

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      message: error?.message || "Unexpected UI error",
    };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    reportClientError({
      event_type: "react_error",
      severity: "ERROR",
      message: error?.message || "React render failed",
      error_name: error?.name || "ReactError",
      stack: error?.stack,
      component_stack: info.componentStack || undefined,
    });
  }

  private reload = () => {
    window.location.reload();
  };

  private goDashboard = () => {
    window.location.href = "/dashboard";
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{ minHeight: "100vh", background: T.pageBg, display: "grid", placeItems: "center", padding: 20 }}>
        <div style={{ width: "min(520px, 100%)", background: T.white, border: `1px solid ${T.border}`, borderRadius: 8, boxShadow: T.pageShadow, overflow: "hidden" }}>
          <div style={{ background: T.headerBg, color: T.white, padding: "16px 18px" }}>
            <div style={{ fontSize: 18, fontWeight: 900 }}>Page recover nahi ho paya</div>
            <div style={{ marginTop: 4, color: T.headerSub, fontSize: 12 }}>Issue server monitor me capture ho gaya hai.</div>
          </div>
          <div style={{ padding: 18 }}>
            <div style={{ background: T.dangerBg, border: `1px solid ${T.dangerBr}`, color: T.dangerText, borderRadius: 6, padding: 12, fontSize: 12, fontWeight: 700, wordBreak: "break-word" }}>
              {this.state.message || "Unexpected UI error"}
            </div>
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 16, flexWrap: "wrap" }}>
              <button onClick={this.goDashboard} style={{ ...btn, background: T.white, color: T.text, border: `1px solid ${T.borderStrong}` }}>
                Dashboard
              </button>
              <button onClick={this.reload} style={{ ...btn, background: T.primary, color: T.white }}>
                Reload Page
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
